import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ListItem, List } from '@mui/material';
import { TranslatedString } from '../../../interfaces';
import RichTextEditor from '../richTextEditor/richTextEditor';
import { DialogTitle } from '../..';
import { Dialog } from '../../2-component';
import { Button } from '../../2-component/button/button.stories';

export interface TranslatableRichTextEditorArgs {
  value?: TranslatedString;
  setValue: (value: TranslatedString) => void;
  id?: string;
  sx?: any;
  minHeight?: string | number;
  label?: string;
  fullToolbar?: boolean;
  testId?: string;
}

const TranslatableRichTextEditor = ({
  value = { en: '' },
  setValue,
  id,
  sx,
  minHeight,
  label,
  fullToolbar,
  testId = 'translatable-rich-text-editor',
}: TranslatableRichTextEditorArgs) => {
  const { t } = useTranslation('components');
  const [open, setOpen] = useState(false);

  return (
    <>
      <RichTextEditor
        testId={`${testId}-outter`}
        value={value?.en ?? ''}
        setValue={(en) => setValue({ ...value, en })}
        id={id}
        sx={sx}
        minHeight={minHeight}
        label={label}
        fullToolbar={fullToolbar}
        type='multiLanguage'
        onTranslate={() => setOpen(!open)}
      />
      <Dialog onClose={() => setOpen(false)} open={open} fullWidth>
        <DialogTitle>{t('translate')} - {label}</DialogTitle>
        <List>
          <ListItem>
            <RichTextEditor
              testId={`${testId}-inner-en`}
              value={value?.en ?? ''}
              setValue={(en) => setValue({ ...value, en })}
              label={t('languages.english')}
              fullToolbar={fullToolbar}
            />
          </ListItem>
          <ListItem>
            <RichTextEditor
              testId={`${testId}-inner-fr`}
              value={value?.fr ?? ''}
              setValue={(fr) => setValue({ ...value, fr })}
              label={t('languages.french')}
              fullToolbar={fullToolbar}
            />
          </ListItem>
          <ListItem>
            <Button
              dataTestId={`${testId}-done-button`}
              fullWidth
              variant='filled'
              onClick={() => setOpen(false)}
              label={t('done')}
            />
          </ListItem>
        </List>
      </Dialog>
    </>
  );
};

export default TranslatableRichTextEditor;
